import Stroke from './Stroke';

export default Stroke;
